import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Navbar.css';
import './LanguageSwitch.css';
import logo from '../Media/LOGOBLANCO.png';
import LanguageSwitch from './LanguageSwitch';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();
  const location = useLocation();

  const items = [
    { label: t.navbar.home, to: '/' },
    { label: t.navbar.about, to: '/about' },
    { label: t.navbar.services, to: '/services' },
    { label: t.navbar.faqs, to: '/faqs' },
    { label: t.navbar.blog, to: '/blog' },
    { label: t.navbar.contact, to: '/contact' }
  ];

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="NavbarItems">
      <div className="navbar-inner container">
        <Link to="/" className="navbar-brand" onClick={() => setOpen(false)}>
          <img src={logo} alt="Innovative Horizons" className="navbar-logo-image" />
        </Link>

        <button
          className="menu-icon"
          onClick={() => setOpen((prev) => !prev)}
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          type="button"
        >
          <i className={open ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <nav className={open ? 'nav-shell active' : 'nav-shell'}>
          <ul className="nav-menu">
            {items.map((item) => (
              <li key={item.to}>
                <Link
                  className={location.pathname === item.to ? 'nav-links active' : 'nav-links'}
                  to={item.to}
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <LanguageSwitch />
            <Link className="nav-cta" to="/contact" onClick={() => setOpen(false)}>
              {t.navbar.cta}
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}